<template>
  <div class="conversion-calculator">
    <div class="cal-title">Unit Conversion Calculator</div>
    <div class="btn-group btn-group-toggle d-flex justify-content-center unit-toggle-group" data-toggle="buttons">
      <label class="btn btn-secondary active">
        <input type="radio" name="options" id="option2" autocomplete="off" @click="toggleArea()">Area
      </label>
      <label class="btn btn-secondary">
        <input type="radio" name="options" id="option1" autocomplete="off" @click="toggleLength()" checked>Length
      </label>
    </div>

    <div style="font-size:18px;font-weight:bold;margin-bottom:10px;">{{physicalQuantity.name}}</div>

    <div class="row">
      <input v-model="fromValue" type="number" class="form-control cal-form col-sm-8" id="unit_input" aria-describedby="tenancy_cost" placeholder="Enters a number and select the unit">
      <select v-model="fromUnit" class="col unit-select form-control ml-3">   <!-- choose unit to convert from -->
        <option value="" disabled selected hidden>Unit</option>
        <option v-for="unit in physicalQuantity.units" v-bind:key="unit"> {{unit}} </option>
      </select>
    </div>
    <div class="row">
      <p id="result" class="form-control cal-form col-sm-8">
        {{result}}
      </p> 
      <select v-model="resultUnit" class="col unit-select form-control ml-3">   <!-- choose unit to convert to -->
        <option value="" disabled selected hidden>Unit</option>
        <option v-for="unit in physicalQuantity.units" v-bind:key="unit"> {{unit}} </option>
      </select>
    </div>
  </div>
</template>

<!-- the logic of this component -->
<script>
export default {
  name: 'Converter',

  data: function(){            // the data available to this component (Converter.vue). It must be a function returning an object (to ensure that each component has its own data)
       return{
         fromValue:1,
         fromUnit:"",
         resultUnit:"",
         physicalQuantity: {name:"Area",id:0, units:["Hectare","Acre","Sq Feet","Meter Sq","Relong"]},
         quantities: [  /*  all physical quantities we are working with and their respective units */
            {name:"Area",id:0, units:["Hectare","Acre","Sq Feet","Meter Sq","Relong"]},
            {name:"Length",id:1, units:["Feet","Meter","Millimeter","Link","Rantai"]}
          ]
       }
  },
  methods:{
      // for each physical quantity, we have an "intermediary" unit and a function for converting values to that unit. That means, when we e.g. convert milimeters to centimeters, we don't do that directly
      // instead, we convert to meters first, and then to centimeters. Makes the programming logic more readable and maintanable. The following functions are used for converting to those intermediary units:
      toMinutes: function(value,unit){   // converts a time value to its corresponding value in minutes
          switch(unit){
            case("Hectare"):
                return value*107636.76;
            case("Acre"):
                return value*43560;
            case("Sq Feet"):
                 return value;
            case("Meter Sq"):
                 return value*10.7639;
            case("Relong"):
                 return value*30976;
            default:
                 return value;
          }
      },
      toMeters: function(value,unit){   // converts a length value to its corresponding value in meters
        switch(unit){
            case("Rantai"):
                return value*66;
            case("Feet"):
                return value;
            case("Meter"):
                return value*3.281;
            case("Millimeter"):
                return value*0.003281;
            case("Link"):
                return value*0.66;
                
            default:
                return value;
        }
      },
      toggleArea: function() {
        let vm = this;
        vm.physicalQuantity.name = vm.quantities[0].name;
        vm.physicalQuantity.units = vm.quantities[0].units;
        return vm.physicalQuantity;
      },
      toggleLength: function() {
        let vm = this;
        vm.physicalQuantity.name = vm.quantities[1].name;
        vm.physicalQuantity.units = vm.quantities[1].units;
        return vm.physicalQuantity;
      }
  },
  computed: {            // "computed" parts of components are reactive values which depend on the value of some other part (in our case, the "fromValue")

      result: function(){
            let value = parseFloat(this.fromValue);  // whatever the user types into the <input> Element, it turns out to be a string. We have to convert it to a number(float) 
            if(isFinite(value)){                   // check if the user really typed in a number (if not, then isFinite returns false)        
                    switch(this.physicalQuantity.name){    // check in which physicalQuantity we are
                case("Area"): {
                    /* ------------A R E A-------------*/
                        let valueInArea = this.toMinutes(value,this.fromUnit);  // we use "minutes" as an intermediary unit
                        switch(this.resultUnit){
                        case("Hectare"):
                            return parseFloat((valueInArea/107636.76).toFixed(5)); 
                        case("Acre"):
                            return parseFloat((valueInArea/43560).toFixed(5)); 
                        case("Sq Feet"):
                            return parseFloat((valueInArea).toFixed(5)); 
                        case("Meter Sq"):
                            return parseFloat((valueInArea/10.7639).toFixed(5)); 
                        case("Relong"):
                            return parseFloat((valueInArea/30976).toFixed(5)); 
                        default:
                            return "Select a unit to be converted to...";
                         }
                }
                  /* ----------------------------*/
                 case("Length"): {
                    /* ------------L E N G T H-------------*/
                        let valueInLength= this.toMeters(value,this.fromUnit);  // we use "meters" as an intermediary unit
                        switch(this.resultUnit){
                        case("Rantai"):
                            return parseFloat((valueInLength/66).toFixed(5));
                        case("Feet"):
                            return parseFloat((valueInLength).toFixed(5));
                        case("Meter"):
                            return parseFloat((valueInLength/3.281).toFixed(5));
                        case("Millimeter"):
                            return parseFloat((valueInLength/0.003281).toFixed(5));
                        case("Link"):
                            return parseFloat((valueInLength/0.66).toFixed(5));
                        default:
                            return "Select a unit to be converted to...";
                        }
                 }


              }
            }
            return "Select a unit to be converted to...";  // if the user didn't type in a number
      }
      
  }
}
</script>

<!-- CSS styling for this component. The "scoped" attribute limits the styling exclusibely to THIS component-->
<style scoped lang="scss">

.unit-toggle-group {
  margin: 20px 0;
    .active {
        background: #FF6767 !important;
        color: #fff;
    }
}

#result{
  border: 1px solid rgb(77, 186, 135);
}

</style>
